import { ServiceCategory } from "./categories";
import { ProService } from "./pro-services";
import { ServiceHandle } from "./service-handle";

export class User {
  id: string;
  firstname: string;
  lastname : string;
  contact : string;
  address : string;
  email : string;

  //Login Details
   username : string;
   password : string;

  //Navigation Property in case a user owns a service
  serviceId : string;
  service: ProService;

  category: ServiceCategory;
  serviceViews: Number;
  serviceHandles: ServiceHandle[];

//Security Property
  token?: string;
}
